import { useEffect, useRef, useState } from "react";

import PanelActionBarComponent from "../../common/PanelActionBarComponent";
import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";
import GenrateDocument from "../../GenrateDocument/GenrateDocument";
// import CaseLoanModal from "../CaseLoanModal";
import { currencyFormat, formatDateForPanelDisplay } from "../../../Utils/helper";
import TreatmentNotesSection from "../../TreatmentPage/NotesTreatmentSection";
import InformationPanel from "../../common/InformationPanel";
import AddCaseLoanModal from "../AddCaseLoanModal";
import DocumentRow from "../../DocumentRow/DocumentRow";
import EditCaseLoanModal from "../EditCaseLoanModal";
import { api_without_cancellation } from "../../../api/api";
import PlaceHolderifNothingAdded from "../../components-new-final/placeholder-nothing-added";
import "../../common/RecordPanel.css";

const LoansAllPage = ({ loans, updateCaseLoansPanels, pageIcon = "" }) => {
  // const { loans, updateCaseLoansPanels } = loansPanelsObj;
  const [height, setHeight] = useState(null);
  const heightRef = useRef(null);
  const [showGenDocPopup, setShowGenDocPopup] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenragteDoc] = useState(null);
  const [dropdownName, setDropdownName] = useState("");
  const [, setActiveTab] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const handleGenrateDocument = (instanceId, dropDownName) => {
    setDropdownName(dropDownName);
    setInstanceIdForGenragteDoc(instanceId);
    setShowGenDocPopup(true);
  };
  useEffect(() => {
    if (heightRef.current) {
      setHeight(heightRef.current.clientHeight);
    }
  }, [heightRef]);
  const [showAddPopup, setShowAddPopup] = useState(false);

  const LenderButtonsConfig = [
    {
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      // style: {
      //   height: "25px",
      //   backgroundColor: "var(--primary-10)",
      //   borderColor: "var(--primary)",
      //   color: "var(--primary)",
      // },
      onClick: handleGenrateDocument,
    },
  ];
  const [selectedLoan, setSelectedLoan] = useState(null);
  const handlePayOffAmount = async (id, amount) => {
    try {
      const payload = {
        loan_id: id,
        final_value: amount,
      };
      const response = await api_without_cancellation.put(
        "/api/caseloan-page/final-payoff/",
        payload
      );
      if (response.status === 200 || response.status === 201) {
        updateCaseLoansPanels();
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      {loans?.length === 0 && (
        <>
          <PlaceHolderifNothingAdded
            text1="No Loan Applications Added to the Case"
            text2="Click to Add"
            pageIcon={pageIcon}
            onClick={() => setShowAddPopup(true)}
          />
          {showAddPopup && (
            <AddCaseLoanModal
              show={showAddPopup}
              handleClose={() => {
                setShowAddPopup(false);
              }}
              updateLoanStates={updateCaseLoansPanels}
            />
          )}
        </>
      )}
      {loans?.length > 0 &&
        loans?.map((loan) => (
          <>
            <div className="report record-panel" key={loan?.id}>
              <PanelActionBarComponent
                compact
                id={loan?.id}
                title={"Lending Company"}
                object={loan}
                buttons={[]}
                page_id={17}
                hasGradient={true}
                name={loan?.lending_company_contact?.name?.toUpperCase()}
                type="Lending Company"
              />
              <div
                className="flex-row d-flex record-panel-body flex-wrap"
                style={{ overflow: "hidden", gap: "5px" }}
              >
                <div ref={heightRef} className="leins-container-three m-b-5">
                  <div className="min-w-260px-client">
                    <ContactPanelForTreatment
                      id={loan?.id}
                      panel_name={"Lending Company"}
                      className=""
                      onSelectObject={() => {
                        setActiveTab("lender_company");
                        setShowEditModal(true);
                        setSelectedLoan(loan);
                      }}
                      pageName="Case Loans"
                      name={loan?.lending_company_contact?.name}
                      dynamic_label={"Company Name"}
                      buttonData={LenderButtonsConfig}
                      phone_number={loan?.lending_company_contact?.phone_number}
                      email={loan?.lending_company_contact?.email}
                      address1={loan?.lending_company_contact?.address1}
                      address2={loan?.lending_company_contact?.address2}
                      city={loan?.lending_company_contact?.city}
                      state={loan?.lending_company_contact?.state}
                      zip_code={loan?.lending_company_contact?.zip}
                      ext={loan?.lending_company_contact?.phone_ext}
                      fax_number={loan?.lending_company_contact?.fax}
                      genrate_doc_address={0}
                      templateDropdownId={0}
                      templatePageId={17}
                      websiteURL={loan?.lending_company_contact?.website}
                    />
                  </div>
                  <div className="min-w-260px-client">
                    <ContactPanelForTreatment
                      id={loan?.id}
                      panel_name={"Lender Contact"}
                      className=""
                      pageName="Case Loans"
                      buttonData={LenderButtonsConfig}
                      onSelectObject={() => {
                        setActiveTab("lender");
                        setShowEditModal(true);
                        setSelectedLoan(loan);
                      }}
                      // dynamic_label="Full Name"
                      phone_number={loan?.contact?.phone_number}
                      email={loan?.contact?.email}
                      name={`${loan?.contact?.first_name} ${loan?.contact?.last_name}`}
                      address1={loan?.contact?.address1}
                      address2={loan?.contact?.address2}
                      city={loan?.contact?.city}
                      state={loan?.contact?.state}
                      zip_code={loan?.contact?.zip}
                      ext={loan?.contact?.phone_ext}
                      fax_number={loan?.contact?.fax}
                      websiteURL={loan?.contact?.website}
                      genrate_doc_address={0}
                      templateDropdownId={0}
                      templatePageId={17}
                    />
                  </div>
                  <div className="min-w-260px-client">
                    <InformationPanel
                      panel_name={"Loan Details"}
                      className=""
                      data={[
                        {
                          label: "Disbursed",
                          value: `${currencyFormat(loan?.current_amount_verified)}`,
                        },
                        {
                          label: "Interest",
                          value: `${loan?.interest} %`,
                        },
                        {
                          label: "Fees",
                          value: `${currencyFormat(loan?.fees)}`,
                        },

                        {
                          label: "Payoff Amount",
                          value: `${currencyFormat(loan?.amount_estimate)}`,
                        },
                        {
                          label: "Final Payoff Recorded Date",
                          value: `${formatDateForPanelDisplay(loan?.final_payoff_recorded)}`,
                        },
                      ]}
                      valueStyle={{
                        maxWidth: "70%",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 1,
                        overflow: "hidden",
                        // color: "var(--primary-25)",
                      }}
                      labelStyle={{
                        maxWidth: "65%",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 1,
                        overflow: "hidden",
                        // color: "var(--primary-25)",
                      }}
                      onSelectReport={() => {
                        setActiveTab("loan_details");
                        setShowEditModal(true);
                        setSelectedLoan(loan);
                      }}
                      panelClassName="m-b-0"
                      defaultLength={5}
                      hasBtn={true}
                      buttonData={[
                        {
                          id: "generate-document-button",
                          // disabled: true,
                          buttonText: loan?.final_amount
                            ? `Record Final Payoff: ${currencyFormat(loan?.final_amount)}`
                            : "Record Final Payoff",
                          className: "p-l-6 p-r-5",
                          style: { height: "25px" },
                          onHover: () => {},
                          onMouseLeave: () => {},
                          onClick: () => {
                            handlePayOffAmount(loan?.id, loan?.final_amount);
                          },
                          disabled: loan?.final_payoff_recorded ? true : false,
                        },
                      ]}
                    />
                  </div>
                </div>
                <div
                  className=""
                  style={{
                    flex: 1,
                    minHeight: "160px",
                    paddingRight: "0px",
                    scrollbarWidth: "none",
                    minWidth: "min(400px, 100%)",
                    maxHeight: `${height}px`,
                  }}
                >
                  <p className="menu-bar-style columnsTitle text-center">Notes</p>
                  <TreatmentNotesSection
                    entity_type={"Loans"}
                    record_id={loan?.id}
                    module={"Loans"}
                    pagePanels={3}
                  />
                </div>
              </div>

              <div className=" documents-wrapper">
                <div className="col-12">
                  {/* <div className="height-25">
                    <h4
                      className="text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case font-weight-semibold text-center client-contact-title"
                      style={{ background: "var(--primary-15)" }}
                    >
                      &nbsp;Document Row
                    </h4>
                  </div> */}
                  {/* page="defendants" */}
                  <DocumentRow clientProvider={loan} page_id={17} showSaveToPage={false} />
                </div>
              </div>
            </div>

            {showGenDocPopup && (
              <GenrateDocument
                PageEntity={"Loans"}
                show={showGenDocPopup}
                handleClose={() => setShowGenDocPopup(false)}
                instanceId={instanceIdForGenrateDoc}
                dropdownName={dropdownName}
              />
            )}

            {showEditModal && (
              <EditCaseLoanModal
                loan={selectedLoan}
                updateLoans={updateCaseLoansPanels}
                show={showEditModal}
                handleClose={() => setShowEditModal(false)}
              />
            )}
          </>
        ))}
    </>
  );
};

export default LoansAllPage;
